// @flow

import React from "react";

import { type InvestmentProps } from "../../types/details";

import InvestmentRealEstate from "./InvestmentRealEstate";
import InvestmentLiquidity from "./InvestmentLiquidity";
import InvestmentGoods from "./InvestmentGoods";
import InvestmentVehicles from "./InvestmentVehicles";
import InvestmentEquipment from "./InvestmentEquipment";
import InvestmentMachine from "./InvestmentMachine";
import InvestmentHardAndSoftware from "./InvestmentHardAndSoftware";
import InvestmentOthers from "./InvestmentOthers";
import InvestmentFinancingTable from "./InvestmentFinancingTable";
import InvestmentCorona from "./InvestmentCorona";
import InvestmentCoronaEstablisher from "./InvestmentCoronaEstablisher";
import InvestmentDevelopmentExpenditure from "./InvestmentDevelopmentExpenditure";
import InvestmentFinancingCheck from "./InvestmentFinancingCheck";

import {
  PURPOSE_KIND,
  PURPOSE_KIND__REAL_ESTATE,
  PURPOSE_KIND__LIQUIDITY,
  PURPOSE_KIND__GOODS,
  PURPOSE_KIND__COMMERCIAL_VEHICLE,
  PURPOSE_KIND__EQUIPMENT,
  PURPOSE_KIND__MACHINERY_AND_TECHNICAL_PLANT,
  PURPOSE_KIND__HARD_SOFTWARE,
  PURPOSE_KIND__OTHER,
  PURPOSE_KIND__CORONA,
  PURPOSE_KIND__DEVELOPMENT_EXPENDITURE,
  PURPOSE_KIND__FINANCE_CHECK
} from "./formFields";
import Section from "../../components/Section";
import { chooseType } from "../../data/dictionary";

const sectionTypes = {
  [PURPOSE_KIND__REAL_ESTATE]: InvestmentRealEstate,
  [PURPOSE_KIND__LIQUIDITY]: InvestmentLiquidity,
  [PURPOSE_KIND__GOODS]: InvestmentGoods,
  [PURPOSE_KIND__COMMERCIAL_VEHICLE]: InvestmentVehicles,
  [PURPOSE_KIND__EQUIPMENT]: InvestmentEquipment,
  [PURPOSE_KIND__MACHINERY_AND_TECHNICAL_PLANT]: InvestmentMachine,
  [PURPOSE_KIND__HARD_SOFTWARE]: InvestmentHardAndSoftware,
  [PURPOSE_KIND__DEVELOPMENT_EXPENDITURE]: InvestmentDevelopmentExpenditure,
  [PURPOSE_KIND__FINANCE_CHECK]: InvestmentFinancingCheck,
  [PURPOSE_KIND__CORONA]: InvestmentCoronaEstablisher,
  [PURPOSE_KIND__OTHER]: InvestmentOthers
};

const Investment = ({
  initialValues,
  handleSubmit,
  isEstablishedEntrepreneur,
  site,
  type
}: InvestmentProps) => {
  const { kind } = initialValues[PURPOSE_KIND][0];
  const SectionTypeEstablisher = sectionTypes[kind];
  const coronaPurposeKind = kind === PURPOSE_KIND__CORONA;
  const SectionTypeSuccessorFounder = coronaPurposeKind
    ? InvestmentCorona
    : InvestmentFinancingTable;
  const isLocked = site === "bank" || coronaPurposeKind;

  return (
    <Section
      title={chooseType(site, type) && chooseType(site, type).investmentSectionTitle}
      reducedMargin
      numbered
    >
      {isEstablishedEntrepreneur ? (
        <SectionTypeEstablisher
          key={kind}
          kind={kind}
          handleSubmit={handleSubmit}
          initialValues={initialValues}
          isLocked={isLocked}
          site={site}
        />
      ) : (
        <SectionTypeSuccessorFounder
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          isLocked={isLocked}
          site={site}
        />
      )}
    </Section>
  );
};

export default Investment;
